module.exports = __webpack_public_path__ + "img/win-s2-icon2.7b337b05.svg";